import axios from "axios";

const axiosClient = axios.create({
  // baseURL: `https://kuponeo.ddev.site`,
  // withCredentials: false, // This is the default
  headers: {
    get: {
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    post: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  }
});

export default {
  getPreviewImage(url, data) {
    return axiosClient.post(url, data).then(
      (response) => {
        return response.data;
      },
      (error) => {
        console.log(error);
      }
    );
  }
};
